import { IConfigStorage } from "../IConfigStorage";
import { TestResultDataType } from "../Testing/TestResultDataType";
import { UnitTestEvaluationType } from "../Testing/UnitTestEvaluationType";
import { DataUtilities } from "../DataUtilities";
import { ITestResultItem } from "../Testing/ITestResultItem";

export class UnitTestResultNode implements IConfigStorage {
    id: string;
    name?: string;
    value: string | undefined;
    type: TestResultDataType;
    isError: boolean = false;
    unitTestEvaluationType: UnitTestEvaluationType = UnitTestEvaluationType.NONE;

    children: UnitTestResultNode[] = [];

    constructor(id: string, name: string | undefined, value: string | undefined, type: TestResultDataType) {
        this.id = id;
        this.name = name;
        this.value = value;
        this.type = type;
    }

    static createResultNode(unitTestItem: ITestResultItem): UnitTestResultNode {
        let resNode = new UnitTestResultNode(
            unitTestItem.itemId,
            unitTestItem.itemName,
            unitTestItem.result,
            unitTestItem.type
        );
        resNode.isError = unitTestItem.isError;

        if (unitTestItem.items) {
            for (let i of unitTestItem.items) {
                resNode.children.push(this.createResultNode(i));
            }
        }

        return resNode;
    }

    getStorageData(): object {
        let data = DataUtilities.addStorageData(this, undefined, "id", "name", "value", "type", "isError");

        Reflect.set(
            data,
            "children",
            this.children.map((c) => c.getStorageData())
        );

        return data;
    }

    setStorageData(data: object): void {
        DataUtilities.setStorageData(this, data, "id", "name", "value", "type", "isError");

        let childrenData = Reflect.get(data, "children");

        for (let c of childrenData) {
            let result = new UnitTestResultNode("", "", "", TestResultDataType.EXPRESSION);
            result.setStorageData(c);
            this.children.push(result);
        }
    }
}
